export default {
  PROFILE_UPDATED: "Profil modifié",
  YOUR_SECURITY: "Votre sécurité",
  ENABLE_2FA: "Activez l'authentification à deux facteurs",
  ENABLE_2FA_AT: "Activé le",
  DISABLE_2FA: "Désactivez l'authentification à deux facteurs",
  DISABLE_2FA_AT: "Désactivé le",
  ENABLE_2FA_SUCCESS:
    "Félicitations ! Vous avez activé la vérification en deux étapes pour sécuriser davantage votre compte. Votre compte est maintenant plus sûr.",
  DISABLE_2FA_SUCCESS:
    "La vérification en deux étapes a été désactivée avec succès. Vous pouvez maintenant vous connecter sans saisir de code supplémentaire.",
};
